import { all, fork, put, select, takeLatest, call } from "redux-saga/effects";
import { REFERENTIELS_SET_PAGINATION, COMMERCIAL_DELETE, COMMERCIAL_CREATE, COMMERCIAL_UPDATE } from "../types";
import { commercialApiUsellProvider } from "../../lib/api/providers";

import { tokenSelector } from "../selectors/auth";

const getState = state => state;

const deleteCommercialApi = (token, id) => {
  return commercialApiUsellProvider.delete(`/${id}`, {
    headers: {
      Authorization: token
    }
  });
};
const createCommercialApi = (token, period) => {
  return commercialApiUsellProvider.post(`/create`, period, {
    headers: {
      Authorization: token
    }
  });
};
const updateCommercialApi = (token, period = {}) => {
  return commercialApiUsellProvider.put(`/${period.id}`, period, {
    headers: {
      Authorization: token
    }
  });
};

function* deleteCommercial({ id }) {
  const state = yield select(getState);
  const commercialState = state["commercial"] || {};
  try {
    const token = yield select(tokenSelector);

    yield call(deleteCommercialApi, token, id);
    yield put({
      type: REFERENTIELS_SET_PAGINATION,
      sectionName: "commercial",
      page: commercialState.page
    });
  } catch (e) {
    console.log(e.message);
  }
}

function* createCommercial({ period }) {
  const state = yield select(getState);
  const stateClient = state["currentClient"] || {};
  const client_id = stateClient.id;
  const commercialState = state["commercial"] || {};
  try {
    const token = yield select(tokenSelector);

    yield call(createCommercialApi, token, { ...period, client_id });
    yield put({
      type: REFERENTIELS_SET_PAGINATION,
      sectionName: "commercial",
      page: commercialState.page
    });
  } catch (e) {
    console.log(e.message);
  }
}
function* updateCommercial({ period }) {
  const state = yield select(getState);
  const commercialState = state["commercial"] || {};
  try {
    const token = yield select(tokenSelector);

    yield call(updateCommercialApi, token, period);
    yield put({
      type: REFERENTIELS_SET_PAGINATION,
      sectionName: "commercial",
      page: commercialState.page
    });
  } catch (e) {
    console.log(e.message);
  }
}
function* watchDeleteCommercial() {
  yield takeLatest(COMMERCIAL_DELETE, deleteCommercial);
}
function* watchCreateCommercial() {
  yield takeLatest(COMMERCIAL_CREATE, createCommercial);
}
function* watchUpdateCommercial() {
  yield takeLatest(COMMERCIAL_UPDATE, updateCommercial);
}
export default function* root() {
  yield all([fork(watchDeleteCommercial), fork(watchCreateCommercial), fork(watchUpdateCommercial)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/commercialSagas.js